import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import type { ResponsiveColorsType } from '@/components/Box';
import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Row } from '@/components/Row';

export const WatchCardContainer = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      background-color: ${theme.colors.lightGrey};
    }
  `}
`;

export const ValidCircle = styled(Box)<{
  backgroundColor: ResponsiveColorsType;
}>`
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor};
  `}
`;

export const Wrapper = styled(Row)`
  grid-gap: ${({ theme }) => theme.spacing(2)};
`;
export const Empty = styled(Flex)`
  margin-inline: auto;
  ${({ theme }) => css`
    ${theme.media.sm.up} {
      padding-top: ${({ theme }) => theme.spacing(4)};
      padding-bottom: ${({ theme }) => theme.spacing(3)};
    }
  `}
`;

export const ImageWrapper = styled(Flex)`
  img {
    object-fit: cover;
  }
`;

export const StyledSwiper = styled(Swiper)`
  display: grid;
  grid-auto-rows: 1fr;
  > .swiper-button {
    &-prev,
    &-next {
      display: none;
    }

    &-prev.swiper-button-disabled,
    &-next.swiper-button-disabled {
      display: none;
    }
  }
  ${({ theme }) => css`
    ${theme.media.md.down} {
      min-height: unset;
    }

    ${theme.mediaQueries.md} {
      > .swiper-button {
        &-prev,
        &-next {
          margin-top: 0;
          color: ${theme.colors.black};
          display: initial;
          top: calc(40% - 50px);
          width: 40px;
          height: 40px;
          justify-content: center;
          align-items: center;
          display: inline-flex;
          ::after {
            font-size: 24px;
          }
        }

        &-prev {
          left: 0;
          text-align: left;
        }

        &-next {
          right: 0;
          text-align: right;
        }
      }
    }
  `}
`;
